import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChecked = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M18.69 7.527a1 1 0 0 1 .033 1.413l-7.875 8.25a1 1 0 0 1-1.43.017l-4.125-4.125a1 1 0 1 1 1.414-1.414l3.401 3.401 7.169-7.51a1 1 0 0 1 1.413-.032",
		clipRule: "evenodd"
	})
});
export default SvgChecked;
